import React from 'react';
import { Building2, ClipboardList, Trophy, TrendingUp } from 'lucide-react';

const shortName = (company) => company.replace(/\s+(Ltd\.?|Limited)$/i, '');

const Card = ({ label, icon: Icon, children }) => (
  <li className="min-w-0 bg-white rounded-2xl border border-slate-200/90 shadow-sm p-4 sm:p-5">
    <div className="flex items-start justify-between gap-2">
      <p className="text-[10px] sm:text-[11px] font-bold uppercase tracking-wider text-slate-500">{label}</p>
      <Icon className="w-4 h-4 text-slate-400 shrink-0" aria-hidden="true" />
    </div>
    {children}
  </li>
);

export const SmeReviewStatCards = ({ stats, year }) => {
  const { tracked, reviewedCount, bullishCount, bullishShare, deskCount, topBrokers, topPick } = stats;

  return (
    <ul className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 sm:gap-4">
      <Card label="Tracked SME Issues" icon={ClipboardList}>
        <div className="mt-2 flex flex-wrap items-baseline gap-x-2 gap-y-1">
          <p className="text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900">{tracked}</p>
          <span className="text-[11px] font-bold text-[#008080]">{reviewedCount} with broker calls</span>
        </div>
        <p className="mt-1.5 text-[11px] text-slate-400">Active {year} SME pipeline</p>
      </Card>

      <Card label="Consensus Bullish" icon={TrendingUp}>
        <div className="mt-2 flex flex-wrap items-baseline gap-x-2 gap-y-1">
          <p className="text-2xl sm:text-3xl font-extrabold tracking-tight text-emerald-600">
            {bullishShare === null ? '—' : `${Math.round(bullishShare)}%`}
          </p>
          <span className="text-[11px] font-semibold text-slate-500">Apply / Must Subscribe</span>
        </div>
        <p className="mt-1.5 text-[11px] text-slate-400">
          {reviewedCount ? `${bullishCount} of ${reviewedCount} reviewed SME issues` : 'Awaiting the first broker calls'}
        </p>
      </Card>

      <Card label="Research Desks" icon={Building2}>
        <div className="mt-2 flex flex-wrap items-baseline gap-x-2 gap-y-1">
          <p className="text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900">{deskCount}</p>
          <span className="text-[11px] font-bold text-[#008080]">{deskCount === 1 ? 'House' : 'Houses'} Active</span>
        </div>
        <p className="mt-1.5 text-[11px] text-slate-400 truncate" title={topBrokers.join(', ')}>
          {topBrokers.length ? topBrokers.join(', ') : 'No SME broker notes yet'}
        </p>
      </Card>

      <Card label={`Top Rated ${year} SME`} icon={Trophy}>
        {topPick ? (
          <>
            <div className="mt-2 flex flex-wrap items-center gap-x-2 gap-y-1">
              <p className="text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900">
                {topPick.subscribeCalls}/{topPick.reviewCount}
              </p>
              <span className="px-2 py-0.5 rounded-md bg-emerald-100 text-emerald-800 text-[11px] font-extrabold">Subscribe</span>
            </div>
            <p className="mt-1.5 text-[11px] text-slate-400 truncate" title={topPick.company}>
              {shortName(topPick.company)}
            </p>
          </>
        ) : (
          <>
            <p className="mt-2 text-lg font-extrabold tracking-tight text-slate-400">No pick yet</p>
            <p className="mt-1.5 text-[11px] text-slate-400">Needs a Subscribe consensus</p>
          </>
        )}
      </Card>
    </ul>
  );
};

export default SmeReviewStatCards;
